{
  "___TODO": "clean this off unused texts",

  "title": "Create Sub-account",
  "next": "Next",
  "finish": "Finish",
  "back": "Back",
  "selectAccount": "Please select an account",
  "topics": {
    "selectAccount": "Select Account",
    "createAccount": "Create Account",
    "createSubAccount": "Create Sub-account",
    "subAccountSummary": "Sub-account Summary"
  },
  "inherited": " - (inherited)",
  "subAccountSummary": {
    "added": "You've successfully added a new sub-account",
    "failed": "Adding a new sub-account failed.",
    "subAccMsg": "Let's connect this goal to a sub-account",
    "subAccountSubTitle": "You've successfully created a sub-account",
    "name": "Name",
    "portfolioTheme": "Portfolio Theme",
    "Portfolio": "Portfolio",
    "requireIPS": "Require Investor Policy Statement",
    "allowClientDeposit": "Allow Client Deposits",
    "allowFractionalShare": "Allow Fractional Share"
  },
  "theyHaveActiveAccounts_one": "This {{entity}} currently has {{count}} active account.",
  "theyHaveActiveAccounts_other": "This {{entity}} currently has {{count}} active accounts.",
  "client": "client",
  "household": "household",
  "corporation": "corporation",
  "useExistingOrCreateNew": "Would you like to use an existing account for your sub-account or create a new one?",
  "createAccountFirst": "Please create a new account first.",
  "actions": {
    "useExsistingAccount": "Use Existing Account",
    "createNewAccount": "Create New Account",
    "createSubAccount": "Create Sub-account",
    "reviewDocuments": "Review Documents",
    "goToSubaccount": "Go to Sub-account",
    "almost": "Almost done..",
    "next": "Next"
  }
}
